import { Link } from 'react-router-dom'
import type { Collection } from '../api/types'
import { Zeichen } from './Zeichen'

/**
 * Sammlungen als quadratische Bilder mit dem Namen darunter.
 *
 * Der Name steht unter dem Bild und nicht darauf: Ein dunkler Verlauf, der
 * weiße Schrift auf jedem Foto rettet, macht jedes Foto unten dunkel, und vier
 * dunkle Kacheln nebeneinander sehen aus wie vier Kacheln, nicht wie vier
 * Bilder.
 *
 * Ohne Bild eine Fläche in der Farbe des Ladens mit dem Anfangsbuchstaben. Eine
 * Reihe, in der eine Kachel kein Bild hat, wirkt dann nicht wie ein Loch,
 * sondern wie eine zweite Sorte Kachel.
 */
export function CollectionGrid({ sammlungen }: { sammlungen: Collection[] }) {
  return (
    <ul className="sf-sammlungen">
      {sammlungen.map((sammlung) => (
        <li key={sammlung.id}>
          <Link className="sf-sammlung" to={`/sammlung/${sammlung.handle}`}>
            <span className="sf-sammlung-bild">
              {sammlung.imageUrl ? (
                /* Leeres alt: Der Name steht gleich darunter; ihn auch ins alt
                   zu schreiben hieße, ihn zweimal vorgelesen zu bekommen. */
                <img src={sammlung.imageUrl} alt="" loading="lazy" decoding="async" />
              ) : (
                <span className="sf-sammlung-initiale" aria-hidden="true">
                  {initiale(sammlung.name)}
                </span>
              )}
            </span>
            <span className="sf-sammlung-name">
              <span>{sammlung.name}</span>
              <Zeichen art="pfeil" groesse={18} />
            </span>
          </Link>
        </li>
      ))}
    </ul>
  )
}

/**
 * Der erste Buchstabe eines Namens — als ganzes Zeichen, nicht als Byte.
 * String[0] risse ein Zeichen außerhalb der ersten Unicode-Ebene in der Mitte
 * durch; der Iterator nimmt ganze Zeichen.
 */
function initiale(name: string): string {
  const [erstes] = name.trim()
  return (erstes ?? '').toLocaleUpperCase()
}
